export function isMotionReduced() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}
